<template>
    <div class="container">
      <h1 class="title">Approval Requests</h1>
  
      <table class="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Parameter</th>
            <th>Update Type</th>
            <th>Data</th>
            <th>Requested By</th>
            <th>Reason</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="request in approvalRequests" :key="request.id">
            <td>{{ request.id }}</td>
            <td>{{ request.model_name }}</td>
            <td>{{ request.action }}</td>
            <td>{{ request.data }}</td>
            <td>{{ request.requested_by }}</td>
            <td>{{ request.reason }}</td>
            <td>
              <button class="button is-success is-small" @click="processRequest(request.id, 'approve')">Approve</button>
              <button class="button is-danger is-small ml-2" @click="processRequest(request.id, 'reject')">Reject</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { toast } from "bulma-toast";
  
  export default {
    name: "ApprovalRequests",
    data() {
      return {
        approvalRequests: []
      };
    },
    methods: {
      async fetchApprovalRequests() {
        try {
          const response = await axios.get("/api/v1/approval-requests/");
          this.approvalRequests = response.data;
        } catch (error) {
          console.error("Error fetching approvals:", error);
        }
      },
      async processRequest(requestId, decision) {
        let rejectionReason = null;

        if (decision === "reject") {
          rejectionReason = prompt("Please enter a reason for rejection:");

          if (!rejectionReason) {
            alert("A rejection reason is required.");
            return;
          }
        }
        if (!confirm(`Are you sure you want to ${decision} this request?`)) return;
        try {
          await axios.post("/api/v1/approve-request/", {
            approval_id: requestId,
            decision: decision,
            rejection_reason: rejectionReason,
          });
  
          toast({ message: `Request ${decision}d successfully`, type: "is-success" });
          this.fetchApprovalRequests();
        } catch (error) {
          console.error("Error processing request:", error);
          toast({ message: `Error ${decision}ing request`, type: "is-danger" });
        }
      }
    },
    async created() {
      this.fetchApprovalRequests();
    }
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: 0 auto;
  }
  .table {
    width: 100%;
    margin-top: 20px;
  }
  </style>
  